<template>
  <v-tooltip top>
    <template v-slot:activator='{ on }'>
      <v-icon
        v-on='on'
        :color='iconData.color'
        :large="!small && !xSmall ? true : false"
        :small='xSmall'
        class='mr-1'
      >{{ iconData.icon }}</v-icon>
    </template>
    <span>{{ iconData.text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'wo-must-do-status',
  props: {
    wo: {
      required: true
    },
    small: {
      required: false,
      type: Boolean,
      default: false
    },
    xSmall: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconData () {
      if (this.wo.apt_date) {
        return {
          icon: 'mdi-calendar',
          color: 'error',
          text: 'Must do - Appointment'
        }
      } else {
        if (this.wo.priority === 1) {
          return {
            icon: 'mdi-exclamation-thick',
            color: 'warning',
            text: 'Should do today'
          }
        } else if (this.wo.priority === 2) {
          return {
            icon: 'mdi-alert',
            color: 'error',
            text: 'Must do today'
          }
        }
      }
      return {
        icon: '',
        color: ''
      }
    }
  }
}
</script>
